import _ from 'underscore';
import PropTypes from 'prop-types';
import $ from 'jquery';
import React, { useCallback, useMemo, useState } from 'react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getBmcMtEndpoint, hasError } from '@bingads-webui-campaign/cpg-product-feed-grid';
import { Loading } from '@bingads-webui-campaign-react/loading';
import { AlertHelper } from '@bingads-webui-campaign/alert-helper';
import { PureBrandSelector } from './pure-brand-selector';
import { getBrandSelectorStyles } from '../../style';

const pageSize = 10;
const emptyResult = {
  items: [],
  totalCount: 0,
};
const i18nLegacy = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');

export const BrandSelectorUnstyled = (props) => {
  const {
    i18n,
    goalSelection,
    onChange,
    scope,
    manuallyAddBrand,
    customizedBrand,
    setCustomizedBrand,
    activity,
    logScope,
    perfMarker,
  } = props;

  const { aid, cid, uid } = scope.values;
  const [loading, setLoading] = useState(false);
  const AlertCenter = useMemo(() => new AlertHelper({ i18n }), [i18n]);

  const onSelectDone = useCallback((selection) => {
    onChange(selection);
  }, [onChange]);

  const fetch = useCallback((param) => {
    const { query, pageNumber } = param;
    if (_.isEmpty(query)) return Promise.resolve(emptyResult);
    const childPerfMarker = perfMarker.createChild('Simplified_SearchBrand');
    childPerfMarker.willInit();
    activity.trace(`${logScope}|BrandSelector|search brand request data: ${JSON.stringify(param)}`);
    setLoading(true);
    return new Promise((resolve) => {
      $.ajax({
        url: `${getBmcMtEndpoint()}/api/v1/manufacturers/${cid}/brands/term-search-v2?cid=${cid}&aid=${aid}&uid=${uid}`,
        type: 'POST',
        xhrFields: {
          withCredentials: true,
        },
        data: `BrandNameTerm=${encodeURIComponent(query)}&Page=${pageNumber + 1}&PageSize=${pageSize}`,
        success: (res) => {
          childPerfMarker.done();
          if (!hasError(res)) {
            AlertCenter.dismissAlert();
            const brandItems = _.map(_.result(res.ResponseObject, 'Brands', []), brand => ({ ...brand, Id: `${brand.BrandName}${brand.BrandUrl}` }));
            activity.trace(`${logScope}|BrandSelector|search brand request succeed: ${JSON.stringify(_.map(brandItems, brand => `${brand.BrandName}(${brand.BrandUrl})}`))}`);
            resolve({
              items: brandItems,
              totalCount: _.get(res.ResponseObject, 'Total', 0),
            });
          } else {
            activity.error(`${logScope}|BrandSelector|search brand failed: ${res.Messages}`);
            AlertCenter.showAlert(res.Messages);
          }
          setLoading(false);
          resolve(emptyResult);
        },
        error: (err) => {
          setLoading(false);
          childPerfMarker.done();
          activity.error(`${logScope}|BrandSelector|search brand request failed: ${JSON.stringify(err)}`);
          AlertCenter.showAlert(_.get(err, ['responseJSON', 'Message']));
          resolve(emptyResult);
        },
      });
    });
  }, [aid, cid, uid, AlertCenter, activity, logScope, perfMarker]);

  return (
    <div>
      {loading && <Loading isVisible />}
      <PureBrandSelector
        i18n={i18n}
        i18nLegacy={i18nLegacy}
        fetch={fetch}
        onSelectDone={onSelectDone}
        selectedItem={null}
        selectedItemsForMultiMode={goalSelection}
        manuallyAddBrand={manuallyAddBrand}
        customizedItem={customizedBrand}
        setCustomizedItem={setCustomizedBrand}
        pageSize={pageSize}
        activity={activity}
        logScope={logScope}
        ariaLabel={i18n.getString(_TL_('Add Brands'))}
        searchBoxAriaLabel={i18n.getString(_TL_('Search Brands'))}
        searchBoxPlaceholder={i18n.getString(_TL_('Search by brand name or domain'))}
        isMultiMode
        isHideSaveBar
      />
    </div>
  );
};

BrandSelectorUnstyled.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  goalSelection: PropTypes.arrayOf(PropTypes.shape({})),
  onChange: PropTypes.func.isRequired,
  scope: PropTypes.shape({
    values: PropTypes.shape({
      aid: PropTypes.string.isRequired,
      cid: PropTypes.string.isRequired,
      uid: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  manuallyAddBrand: PropTypes.func.isRequired,
  customizedBrand: PropTypes.shape({}).isRequired,
  setCustomizedBrand: PropTypes.func.isRequired,
  activity: PropTypes.shape({
    trace: PropTypes.func.isRequired,
    error: PropTypes.func.isRequired,
  }).isRequired,
  logScope: PropTypes.string.isRequired,
  perfMarker: PropTypes.shape({
    createChild: PropTypes.func.isRequired,
  }).isRequired,
};

BrandSelectorUnstyled.defaultProps = {
  goalSelection: [],
};

export const BrandSelector = withDefaultStyles(BrandSelectorUnstyled, getBrandSelectorStyles);

